import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'timestamp',
    pure: false
})
export class TimestampToString implements PipeTransform {
    transform(date: any, args?: any): any {
        if(date=='' || date == '0000-00-00 00:00:00')
            return null;


        date = ((date+(date.indexOf(':') > -1? '' : 'T00:00:01')).replace('UTC',' ').replace('Z',' ').replace('.000','').replace('+0000','')).trim()+'+00:00';//.replace(/-/g, "/").replace('T',' ')

        return new Date(date);
        //return new Date(date.replace(/-/g, "/"));
    }
}